import { type FC, type JSX, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  Accordion,
  AccordionDetails,
  AccordionStack,
  AccordionSummary,
  Link,
} from 'base-ui'

import {
  type PublicGlobalConfig,
  useGlobalConfigContext,
} from '../../../../global-config'
import { urlResolverGetFaq } from '../../../../url-handling'

type QaSectionData = {
  answer: JSX.Element
  key: string
  question: JSX.Element
}

const lineBreak = (): JSX.Element => {
  return <br />
}

const link = (text: ReactNode[], config: PublicGlobalConfig): JSX.Element => (
  <Link
    data-qa-id="rx.com.faq.more.info"
    href={urlResolverGetFaq(config)}
    rel="noreferrer"
    target="_blank"
  >
    {text}
  </Link>
)

const faqQuestions = (): QaSectionData[] => [
  {
    answer: (
      <FormattedMessage
        id="rx.com.faq.answer.1"
        values={{
          break: lineBreak,
        }}
      />
    ),
    key: 'rx.com.faq.question.1',
    question: <FormattedMessage id="rx.com.faq.question.1" />,
  },
  {
    answer: (
      <p>
        <FormattedMessage id="rx.com.faq.answer.2" />
      </p>
    ),
    key: 'rx.com.faq.question.2',
    question: <FormattedMessage id="rx.com.faq.question.2" />,
  },
  {
    answer: (
      <p>
        <FormattedMessage id="rx.com.faq.answer.3" />
      </p>
    ),
    key: 'rx.com.faq.question.3',
    question: <FormattedMessage id="rx.com.faq.question.3" />,
  },
  {
    answer: (
      <p>
        <FormattedMessage id="rx.com.faq.answer.4" />
      </p>
    ),
    key: 'rx.com.faq.question.4',
    question: <FormattedMessage id="rx.com.faq.question.4" />,
  },
  {
    answer: (
      <p>
        <FormattedMessage id="rx.com.faq.answer.5" />
      </p>
    ),
    key: 'rx.com.faq.question.5',
    question: <FormattedMessage id="rx.com.faq.question.5" />,
  },
  {
    answer: (
      <p>
        <FormattedMessage id="rx.com.faq.answer.6" />
      </p>
    ),
    key: 'rx.com.faq.question.6',
    question: <FormattedMessage id="rx.com.faq.question.6" />,
  },
]

export const RxLpComFaq: FC = () => {
  const config = useGlobalConfigContext()

  return (
    <div className="py-8 tablet:flex tablet:justify-center tablet:pb-2">
      <div className="container flex flex-col gap-6 px-4">
        <span className="text-center text-xl font-medium text-dark-primary-max tablet:text-3xl">
          <FormattedMessage id="rx.com.faq.title" />
        </span>
        <AccordionStack>
          {faqQuestions().map(({ answer, key, question }) => (
            <Accordion key={key}>
              <AccordionSummary>{question}</AccordionSummary>
              <AccordionDetails className="prose">{answer}</AccordionDetails>
            </Accordion>
          ))}
        </AccordionStack>
        <span className="text-left text-s font-medium">
          <FormattedMessage
            id="rx.com.faq.more.info"
            values={{
              link: (text) => link(text, config),
            }}
          />
        </span>
      </div>
    </div>
  )
}
